<script lang="ts"> 
  import { Badge, Col, Form, Label, Row } from "sveltestrap";
  import {  SolidBorderStyle, SolidMeassag } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Forms/FormsControls/Megaoption.json";
  import Card from "../../../Core/Card.svelte";
  import FormFooter from "./FormFooter.svelte";
</script>
<Col sm="12" xl="6">
  <Card cardBodyprops="megaoptions-border-space-sm" headerTitle={SolidBorderStyle} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{SolidMeassag}</span>
    </div>
    <div slot="contentbody">
      <Form class="mega-inline border-style">
        <Row>
          {#each data.defaultdata as formItem }
            <Col sm="6">
              <div class="card">
                <div class="media p-20">
                  <div class="form-check radio radio-{formItem.color} me-3">
                    <input class="form-check-input" id="{formItem.id}2" type="radio" name="radio1" value="option1">
                    <Label class="form-check-label" for="{formItem.id}2"></Label>
                  </div>
                  <div class="media-body">
                    <h6 class="mt-0 mega-title-badge">{formItem.name}
                      <Badge color={formItem.color} class="pull-right digits">{formItem.badge}</Badge>
                    </h6>
                    <p>{formItem.detail}</p>
                  </div>
                </div>
              </div>
            </Col>
          {/each}
        </Row>
      </Form>
    </div>
    <div slot="contentfooter">
      <FormFooter />
    </div>
  </Card>
</Col>